<div class="row">
    <div [ngClass]="isEdit || isAdd || isEditQuestions ? 'col-sm-4' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.opportunityQuestionCategoryID)"><i class="fas fa-pencil-alt"></i></button>
                    <button type="button" class="btn btn-sml btn-secondary m-1" title="Edit Questions" tabindex="-1" (click)="editQuestions(dataItem.opportunityQuestionCategoryID)"><i class="fas fa-list-ol"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.opportunityQuestionCategoryID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="opportunityQuestionCategoryID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="abbreviation" title="Abbreviation"></kendo-grid-column>
            <kendo-grid-column field="description" title="Description"></kendo-grid-column>
            <kendo-grid-column field="sortOrder" title="Sort Order"></kendo-grid-column>
            <kendo-grid-column field="retired" title="Retired">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.retired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd && !isEditQuestions">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-8" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <opportunity-question-category-form [tableID]="tableID" (onRefresh)="cancelEdit()"></opportunity-question-category-form>
    </div>

    <div class="col-sm-8" *ngIf="isEditQuestions">
        <!-- Edit Questions form -->
        <opportunity-question-grid [tableID]="tableID" (onRefresh)="cancelEdit()"></opportunity-question-grid>
    </div>
</div>
